import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  linkedSignal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterOutlet } from '@angular/router';
import { CheckoutStore } from '@seatix/checkout-data-access';
import { SUCCESS_GRADIENT_BG_STYLE } from '@seatix/checkout-ui';
import { injectBreakpoint } from '@seatix/shared-config';
import { injectCurrentUrl } from '@seatix/shared/utils';
import { CheckoutHeaderComponent } from './checkout-header/checkout-header.component';

@Component({
  selector: 'stx-checkout-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, MatToolbarModule, CheckoutHeaderComponent],
  host: {
    class: 'flex flex-col flex-1 min-h-0 xl:max-h-[960px]',
    '[class.overflow-y-auto]': 'isSuccessPage()',
    '[class.stx-success-gradient-bg]': 'isSuccessPage()',
    '[class.text-on-background]': 'isSuccessPage()',
    '[style.--mat-toolbar-container-background-color]':
      'isSuccessPage() ? "transparent" : null',
    '[style.--mat-sys-outline-variant]':
      'isSuccessPage() ? "transparent" : null',
  },
  styles: [SUCCESS_GRADIENT_BG_STYLE],
  template: `
    @if (!isSuccessPage()) {
      <stx-checkout-header class="shrink-0" />
    }
    <main class="flex min-h-0 flex-1 xl:container xl:mx-auto">
      <router-outlet />
    </main>
  `,
})
export class CheckoutFeatLayoutComponent {
  screenMd = injectBreakpoint('md');
  router = inject(Router);
  #store = inject(CheckoutStore);
  #destroyRef = inject(DestroyRef);
  readonly isMobile = computed(() => !this.screenMd());
  readonly url = toSignal(injectCurrentUrl());
  readonly isSuccessPage = linkedSignal(() => this.url()?.includes('/success'));
  readonly showPaymentReference = this.#store.showPaymentReference;
  readonly shouldShowFooter = computed(
    () => !this.isSuccessPage() && !this.showPaymentReference(),
  );

  constructor() {
    this.#destroyRef.onDestroy(() => {
      this.#store.resetCountdown();
    });
  }
}
